module.exports = __webpack_public_path__ + "static/media/hero.8424d5bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero.svg
// module id = 1378
// module chunks = 0